import type { Theme } from "@mui/material/styles";
import type { AppGuideComponentStyles } from "../types";

export function buildGuideComponentStyles(_theme: Theme): AppGuideComponentStyles {
  return {
    analysisPanelHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2,
      py: 1.5,
      borderBottom: 1,
      borderColor: "divider",
      flexShrink: 0,
    },
    analysisPanelBody: { flex: 1, minHeight: 0, p: 2, overflow: "auto" },
    analysisViewBody: {
      m: 0,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      fontFamily: "inherit",
      fontSize: "0.875rem",
      lineHeight: 1.6,
      maxHeight: "60vh",
      overflow: "auto",
    },
    draftActionsRow: { display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "flex-end" },
  };
}
